export default __webpack_public_path__ + "static/03.08-2964380567a7165fa23fd38a236ccc12.png";